import 'antd/es/input/style/index.css';
import 'antd/es/modal/style/index.css';
import 'antd/es/select/style/index.css';
import 'antd/es/switch/style/index.css';
import 'antd/es/divider/style/index.css';
import "leaflet/dist/leaflet.css";
import React from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import "./static/css/banner.css";
import "./static/css/index.css";
import "./static/css/navbar.css";
import {store} from "./store/store";
import {initLogging} from "./utils/logger";


// Глобальные обработчики ошибок + eruda-консоль по ?debug=1 (до первого рендера)
initLogging();

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
    <ErrorBoundary>
        <Provider store={store}>
            <ToastContainer limit={3}/>
            <App/>
        </Provider>
    </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
